export default function Footer() {
    return (
        <div className="footer">
            <h3 className="footer-p">Copyright 2023 © <a href="https://bowoadej.com">Bowo Adejuyigbe</a></h3>
        </div>
    )
}